import React from 'react';
import { Rocket, User, Users, Building2, Hammer } from 'lucide-react';
import { audienceData } from '../../data/mock';

const iconMap = {
  Rocket,
  User,
  Users,
  Building2,
  Hammer,
};

const AudienceSection = () => {
  return (
    <section className="section-light section-padding">
      <div className="container" style={{ padding: '0 5%' }}>
        <div 
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '80px',
            alignItems: 'center',
          }}
        >
          {/* Content */}
          <div>
            <h2 className="section-title section-title-light">
              {audienceData.title}
            </h2>

            {/* Audience Grid */}
            <div 
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '16px',
                marginTop: '40px',
              }}
            >
              {audienceData.audiences.map((audience, i) => {
                const IconComponent = iconMap[audience.icon];
                return (
                  <div
                    key={i}
                    style={{
                      background: '#f8f9fa',
                      border: '1px solid #e0e0e0',
                      padding: '24px 16px',
                      textAlign: 'center',
                      transition: 'all 0.3s ease',
                      cursor: 'default',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = '#f06a15';
                      e.currentTarget.style.background = '#fff5f0';
                      e.currentTarget.style.transform = 'translateY(-4px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = '#e0e0e0';
                      e.currentTarget.style.background = '#f8f9fa';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    <div 
                      style={{
                        width: '48px',
                        height: '48px',
                        margin: '0 auto 12px',
                        background: '#fff',
                        border: '1px solid #e0e0e0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <IconComponent size={24} color="#f06a15" />
                    </div>
                    <span 
                      style={{
                        fontSize: '14px',
                        fontWeight: 600,
                        color: '#333',
                      }}
                    >
                      {audience.name}
                    </span>
                  </div>
                );
              })}
            </div>

            {/* Closing */}
            <p 
              style={{
                fontSize: '20px',
                fontWeight: 600,
                color: '#0a0a0a',
                marginTop: '40px',
                lineHeight: 1.5,
              }}
            >
              {audienceData.closing}
            </p>
          </div>

          {/* Image */}
          <div style={{ position: 'relative' }}>
            <div 
              style={{
                overflow: 'hidden',
                boxShadow: '0 30px 80px rgba(0, 0, 0, 0.15)',
              }}
            >
              <img 
                src={audienceData.image}
                alt="Target Audience"
                style={{
                  width: '100%',
                  height: '450px',
                  objectFit: 'cover',
                }}
              />
            </div>
            {/* Decorative */}
            <div 
              style={{
                position: 'absolute',
                bottom: '-20px',
                left: '-20px',
                width: '150px',
                height: '150px',
                border: '2px solid #f06a15',
                opacity: 0.2,
                zIndex: -1,
              }}
            />
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .section-light .container > div {
            grid-template-columns: 1fr !important;
          }
          .section-light .container > div > div:first-child > div:nth-child(2) {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
      `}</style>
    </section>
  );
};

export default AudienceSection;
